import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import { makeStyles } from '@mui/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
//import ListSubheader from '@mui/material/ListSubheader';
import Select from '@mui/material/Select';
import { Button } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import RcSwitch from 'rc-switch';
import { TransferListRow } from './TransferList';
//import TextField from '@mui/material/TextField';

//import { default as ReactSelect } from 'react-select';
import { SelectAll } from './SelectAll';
import { validateEdgeSchemaTypeMatch, validateNodeSchemaTypeMatch } from './bindings';
import { CategoryRowsComponent } from './CategoryRowsComponent';
import logger from '../utils/logger';
var log = logger.createLogger('ShaperSimple');
import styles from '../styles/file-uploader.less';
import { STATUS_COMPRESSING, STATUS_UPLOADING, STATUS_DONE, STATUS_ERROR, STATUS_COMPRESSED } from './compressFile';
import { inferHyperedges } from './inference';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120
    }
  };
});
var FORM_CONTROL_STYLE = {
  'minWidth': '10em'
};
function serializeTableKey(fileIndex, tableIndex) {
  if (!(fileIndex > -1) || !(tableIndex > -1)) {
    return "";
  }
  return JSON.stringify({
    fileIndex: fileIndex,
    tableIndex: tableIndex
  });
}
function deserializeTableKey(key) {
  log.debug({
    key: key
  }, '@deserializeTableKey');
  if (!key || key === "") {
    return {
      fileIndex: null,
      tableIndex: null
    };
  }
  return JSON.parse(key);
}
function serializeColumnKey(fileIndex, tableIndex, columnName) {
  if (!(fileIndex > -1) || !(tableIndex > -1) || !columnName) {
    return "";
  }
  return JSON.stringify({
    fileIndex: fileIndex,
    tableIndex: tableIndex,
    columnName: columnName
  });
}
function deserializeColumnKey(key) {
  log.debug({
    key: key
  }, '@deserializeColumnKey');
  if (!key || key === "") {
    return {
      fileIndex: null,
      tableIndex: null,
      columnName: null
    };
  }
  return JSON.parse(key);
}
function serializeAttributeKeys(cols) {
  log.debug({
    cols: cols
  }, '@serializeAttributeKeys');
  return (cols || []).map(function (col) {
    return {
      label: col,
      value: col
    };
  });
}
function deserializeAttributeKeys(keys) {
  log.debug({
    keys: keys
  }, '@deserializeAttributeKeys');
  return (keys || []).map(function (_ref) {
    var value = _ref.value;
    return value;
  });
}

//files:: []{name, status, fileStats: {name, is_uploaded, is_valid, tables_schemas[]: {name, num_rows, num_cols, dtypes}}}
function FileTableSelector(_ref2) {
  var visible = _ref2.visible,
    user = _ref2.user,
    files = _ref2.files,
    visualizationBindings = _ref2.visualizationBindings,
    setVisualizationBindings = _ref2.setVisualizationBindings,
    id = _ref2.id,
    defaultValueKey = _ref2.defaultValueKey,
    valueSetter = _ref2.valueSetter;
  log.debug({
    id: id,
    defaultValueKey: defaultValueKey
  }, 'FileTableSelector::render');
  var componentName = "grouped-select-table-".concat(id);
  if (!files || !files.length) {
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(FormControl, {
        variant: "standard",
        className: styles['table-selector'],
        style: FORM_CONTROL_STYLE,
        children: [/*#__PURE__*/_jsx(InputLabel, {
          htmlFor: componentName,
          children: "File & table"
        }), /*#__PURE__*/_jsx(Select, {
          id: "".concat(componentName, "-id"),
          defaultValue: '',
          value: "",
          label: "File & table"
        })]
      })
    });
  }
  var options = [];
  files.forEach(function (_ref3, fileIndex) {
    var name = _ref3.name,
      status = _ref3.status,
      fileStats = _ref3.fileStats,
      error = _ref3.error;
    options.push(/*#__PURE__*/_jsx(InputLabel, {
      htmlFor: componentName,
      className: styles['select-table-file'],
      children: name
    }, "k-".concat(fileIndex)));
    var key = {
      key: "k2-".concat(fileIndex)
    };
    if ([STATUS_COMPRESSING, STATUS_COMPRESSED, STATUS_UPLOADING].includes(status)) {
      options.push(/*#__PURE__*/_jsx(InputLabel, _objectSpread(_objectSpread({
        htmlFor: componentName,
        className: "".concat(styles['select-table-file-error'], " ").concat(styles['invalid'])
      }, key), {}, {
        children: _defineProperty(_defineProperty(_defineProperty({}, STATUS_COMPRESSING, 'Compressing'), STATUS_COMPRESSED, 'About to upload'), STATUS_UPLOADING, 'Uploading')[status]
      })));
      return;
    }
    var _ref12 = fileStats || {},
      is_uploaded = _ref12.is_uploaded,
      is_valid = _ref12.is_valid,
      tables_schemas = _ref12.tables_schemas;
    if (status === STATUS_ERROR) {
      options.push(/*#__PURE__*/_jsxs(InputLabel, _objectSpread(_objectSpread({
        htmlFor: componentName,
        className: "".concat(styles['select-table-file-error'], " ").concat(styles['not-validated'])
      }, key), {}, {
        children: [" \u274C ", error]
      })));
      return;
    }
    if (!fileStats) {
      log.warn({
        file: files[fileIndex]
      }, 'Missing field fileStats');
    }
    if (!is_uploaded) {
      options.push(/*#__PURE__*/_jsx(InputLabel, _objectSpread(_objectSpread({
        htmlFor: componentName,
        className: "".concat(styles['select-table-file-error'], " ").concat(styles['not-uploaded'])
      }, key), {}, {
        children: " \u274C Not uploaded"
      })));
      return;
    }
    if (!is_valid) {
      options.push(/*#__PURE__*/_jsx(InputLabel, _objectSpread(_objectSpread({
        htmlFor: componentName,
        className: "".concat(styles['select-table-file-error'], " ").concat(styles['not-validated'])
      }, key), {}, {
        children: " \u274C Not parsed"
      })));
      return;
    }
    if (status !== STATUS_DONE) {
      options.push(/*#__PURE__*/_jsx(InputLabel, _objectSpread(_objectSpread({
        htmlFor: componentName,
        className: "".concat(styles['select-table-file-error'], " ").concat(styles['not-validated'])
      }, key), {}, {
        children: " Not done"
      })));
      return;
    }
    tables_schemas.forEach(function (_ref4, tableIndex) {
      var name = _ref4.name,
        num_rows = _ref4.num_rows,
        num_cols = _ref4.num_cols;
      var key = serializeTableKey(fileIndex, tableIndex);
      options.push(/*#__PURE__*/_jsxs(MenuItem, {
        value: key,
        className: 'select-table-table',
        children: [name, " (", num_rows, " x ", num_cols, ")"]
      }, key));
    });
  });
  var val = defaultValueKey !== "" && defaultValueKey !== undefined && defaultValueKey != "{\"fileIndex\":null,\"tableIndex\":null}" ? {
    value: defaultValueKey
  } : {
    defaultValue: '',
    value: ''
  };
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(FormControl, {
      variant: "standard",
      className: styles['table-selector'],
      style: FORM_CONTROL_STYLE,
      children: [/*#__PURE__*/_jsx(InputLabel, {
        htmlFor: componentName,
        children: "File & table"
      }), /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
        id: "".concat(componentName, "-id"),
        label: "File & table"
      }, val), {}, {
        onChange: valueSetter,
        children: options
      }))]
    })
  });
}

//files:: []{name, status, fileStats: {name, is_uploaded, is_valid, tables_schemas[]: {name, num_rows, num_cols, dtypes}}}
function FileTableColumnSelector(_ref5) {
  var visible = _ref5.visible,
    user = _ref5.user,
    files = _ref5.files,
    visualizationBindings = _ref5.visualizationBindings,
    setVisualizationBindings = _ref5.setVisualizationBindings,
    id = _ref5.id,
    label = _ref5.label,
    columnPrettyName = _ref5.columnPrettyName,
    fileIndex = _ref5.fileIndex,
    tableIndex = _ref5.tableIndex,
    defaultValueKey = _ref5.defaultValueKey,
    valueSetter = _ref5.valueSetter;
  log.debug({
    id: id,
    fileIndex: fileIndex,
    tableIndex: tableIndex,
    defaultValueKey: defaultValueKey
  }, 'FileTableColumnSelector::render');
  var componentName = "grouped-select-column-".concat(id);
  function mt() {
    log.debug('FileTableColumnSelector mt');
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(FormControl, {
        variant: "standard",
        className: styles['column-selector'],
        style: FORM_CONTROL_STYLE,
        children: [/*#__PURE__*/_jsxs(InputLabel, {
          htmlFor: componentName,
          children: ["Column ", columnPrettyName]
        }), /*#__PURE__*/_jsx(Select, {
          id: "".concat(componentName, "-id"),
          defaultValue: '',
          value: '',
          label: "Column ".concat(columnPrettyName)
        }), /*#__PURE__*/_jsx(FormHelperText, {
          children: label
        })]
      })
    });
  }
  if (!files || !files.length || fileIndex === null || tableIndex === null) {
    return mt();
  }
  var fileObj = files[fileIndex];
  if (!fileObj) {
    log.error({
      fileIndex: fileIndex,
      files: files
    }, 'Invalid file lookup');
    return mt();
  }
  var tableObj = fileObj.fileStats.tables_schemas[tableIndex];
  if (!tableObj) {
    log.error({
      tableIndex: tableIndex,
      files: files
    }, 'Invalid table lookup');
    return mt();
  }
  log.debug({
    fileObj: fileObj,
    tableObj: tableObj
  }, 'FileTableColumnSelector options base');
  var options = Object.keys(tableObj.dtypes).map(function (col, optionIndex) {
    var key = serializeColumnKey(fileIndex, tableIndex, col);
    return /*#__PURE__*/_jsx(MenuItem, {
      value: key,
      className: 'select-column-col',
      children: col
    }, optionIndex);
  });
  var val = defaultValueKey != "" && defaultValueKey !== undefined && defaultValueKey !== 'undefined' ? {
    value: defaultValueKey
  } : {
    defaultValue: '',
    value: ''
  };
  log.debug({
    val: val,
    options: options,
    fileIndex: fileIndex,
    tableIndex: tableIndex
  }, 'rendering column selector');
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(FormControl, {
      variant: "standard",
      className: styles['column-selector'],
      style: FORM_CONTROL_STYLE,
      children: [/*#__PURE__*/_jsxs(InputLabel, {
        htmlFor: componentName,
        children: ["Column ", columnPrettyName]
      }), /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
        id: "".concat(componentName, "-id"),
        label: "Column ".concat(columnPrettyName),
        onChange: valueSetter
      }, val), {}, {
        children: options
      })), /*#__PURE__*/_jsx(FormHelperText, {
        children: label
      })]
    })
  });
}
function AttributeMultiSelector(_ref6) {
  var visible = _ref6.visible,
    user = _ref6.user,
    files = _ref6.files,
    visualizationBindings = _ref6.visualizationBindings,
    setVisualizationBindings = _ref6.setVisualizationBindings,
    id = _ref6.id,
    fileIndex = _ref6.fileIndex,
    tableIndex = _ref6.tableIndex,
    fixedKeys = _ref6.fixedKeys,
    defaultValueKeys = _ref6.defaultValueKeys,
    valuesKeys = _ref6.valuesKeys,
    valueSetter = _ref6.valueSetter;
  log.debug({
    id: id,
    fileIndex: fileIndex,
    tableIndex: tableIndex,
    fixedKeys: fixedKeys,
    defaultValueKeys: defaultValueKeys
  }, 'AttributeMultiSelector::render');
  var componentName = "attrib-multiselector-".concat(id);
  function wrapper(body) {
    return /*#__PURE__*/_jsxs(Form.Group, {
      as: Row,
      className: styles['attrib-multiselector-container'],
      children: [/*#__PURE__*/_jsx(Form.Label, {
        label: 'Attributes',
        children: "Attributes"
      }), /*#__PURE__*/_jsx(Col, {
        children: body
      })]
    });
  }
  function mt() {
    return wrapper(/*#__PURE__*/_jsx(SelectAll, {
      id: "".concat(componentName, "-id"),
      className: styles['attribute-selector'],
      isClearable: true,
      isMulti: true,
      isSearchable: true,
      options: [],
      value: []
    }));
  }
  if (!files || !files.length || fileIndex === null || tableIndex === null) {
    return mt();
  }
  var fileObj = files[fileIndex];
  if (!fileObj) {
    log.error({
      fileIndex: fileIndex,
      files: files
    }, 'Invalid file lookup');
    return mt();
  }
  var tableObj = fileObj.fileStats.tables_schemas[tableIndex];
  if (!tableObj) {
    log.error({
      tableIndex: tableIndex,
      files: files
    }, 'Invalid table lookup');
    return mt();
  }

  //send/receive values in serialized form of {value, label}
  return wrapper(/*#__PURE__*/_jsx(SelectAll, {
    id: "".concat(componentName, "-id"),
    className: styles['attribute-selector'],
    isClearable: true,
    isMulti: true,
    isSearchable: true,
    onChange: function onChange(keys) {
      valueSetter(keys);
    },
    options: Object.keys(tableObj.dtypes).map(function (col) {
      return {
        value: col,
        label: col
      };
    }),
    value: valuesKeys
  }));
}
function setShapeProperties(setVisualizationBindings, shape, newProps) {
  log.debug({
    shape: shape,
    newProps: newProps
  }, 'setShapeProperties pre');
  setVisualizationBindings(function (bindings) {
    log.debug({
      shape: shape,
      newProps: newProps,
      bindings: bindings
    }, 'setShapeProperties');
    return _objectSpread(_objectSpread({}, bindings), {}, {
      shaper: _objectSpread(_objectSpread({}, bindings.shaper), {}, {
        simple: _objectSpread(_objectSpread({}, bindings.shaper.simple), {}, _defineProperty({}, shape, _objectSpread(_objectSpread({}, bindings.shaper.simple[shape]), newProps)))
      })
    });
  });
}
function sortEdges(edges) {
  var out = {};
  for (var _i = 0, _Object$entries = Object.entries(edges); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      s = _Object$entries$_i[0],
      ds = _Object$entries$_i[1];
    out[s] = ds.sort();
  }
  return out;
}

// -> [ elt ]
function HyperedgesComponent(_ref7) {
  var hyperedges = _ref7.hyperedges,
    files = _ref7.files,
    fileIndex = _ref7.fileIndex,
    tableIndex = _ref7.tableIndex,
    onChange = _ref7.onChange,
    setHyperedgeBindings = _ref7.setHyperedgeBindings;
  function mt() {
    return /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: ["First pick a file & table (", files + '', ": ", fileIndex, "/", tableIndex, ")"]
        })
      }, "k-0")
    });
  }
  if (!files || !files.length || fileIndex === null || tableIndex === null) {
    return mt();
  }
  var fileObj = files[fileIndex];
  if (!fileObj) {
    log.error({
      fileIndex: fileIndex,
      files: files
    }, 'Invalid file lookup');
    return mt();
  }
  var tableObj = fileObj.fileStats.tables_schemas[tableIndex];
  if (!tableObj) {
    log.error({
      tableIndex: tableIndex,
      files: files
    }, 'Invalid table lookup');
    return mt();
  }

  //TODO default set when this is the case
  var hyper = hyperedges && (hyperedges.opts && hyperedges.opts.EDGES || hyperedges.entity_types) ? hyperedges : {
    opts: {
      EDGES: {},
      categories: {}
    }
  };
  log.info({
    hyper: hyper,
    hyperedges: hyperedges,
    tableObj: tableObj
  }, 'hyper');
  //onChange

  var edges = sortEdges((hyper.opts || {}).EDGES || {});
  var rows = Object.entries(edges).map(function (_ref8, i) {
    var _ref13 = _slicedToArray(_ref8, 2),
      s = _ref13[0],
      ds = _ref13[1];
    var unclaimedSources = Object.keys(tableObj.dtypes).filter(function (k) {
      return !edges[k] || k === s;
    });
    return /*#__PURE__*/_jsx(TransferListRow, {
      source: s,
      allowedSources: unclaimedSources,
      destinations: ds,
      table: tableObj,
      onChange: onChange,
      setHyperedgeBindings: setHyperedgeBindings
    }, "k-".concat(i));
  });
  var mergeAllCategories = !!hyper.mergeAllCategories;
  var specifyCategories = !!hyper.specifyCategories;
  var hyperNodeLabelShort = "Connect a row's values to a row \"hyper\" node";
  var hyperNodeLabel = "".concat(hyperNodeLabelShort, " (off: link directly to one another)");
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsxs(Col, {
        children: ["direct: ", "".concat(hyper.direct)]
      }), /*#__PURE__*/_jsxs(Col, {
        children: ["allToAll: ", "".concat(hyper.allToAll)]
      })]
    }), /*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsxs(Card.Body, {
        children: [/*#__PURE__*/_jsx(Card.Title, {
          children: "Edges: Turn row values into nodes and link them"
        }), /*#__PURE__*/_jsxs(ListItem, {
          children: [/*#__PURE__*/_jsx(RcSwitch, {
            onChange: function onChange(value) {
              setHyperedgeBindings(function (bindings) {
                return _objectSpread(_objectSpread({}, bindings), {}, {
                  direct: !hyper.direct
                });
              });
            },
            checked: !hyper.direct,
            checkedChildren: 'on',
            unCheckedChildren: 'on'
          }), hyperNodeLabel]
        }), /*#__PURE__*/_jsxs(ListItem, {
          disabled: !hyper.direct,
          children: [/*#__PURE__*/_jsx(RcSwitch, {
            disabled: !hyper.direct,
            onChange: function onChange(value) {
              setHyperedgeBindings(function (bindings) {
                return _objectSpread(_objectSpread({}, bindings), {}, {
                  allToAll: !hyper.allToAll
                });
              });
            },
            checked: !hyper.allToAll,
            checkedChildren: 'on',
            unCheckedChildren: 'on'
          }), "Specify individual src/dst column pairs (off: link all-to-all)", !hyper.direct ? /*#__PURE__*/_jsxs("p", {
            children: [/*#__PURE__*/_jsx("br", {}), "\xA0(Cannot use with '", hyperNodeLabelShort, "')"]
          }) : null]
        }), /*#__PURE__*/_jsx(Divider, {
          className: styles['form-divider']
        }), !!hyper.allToAll || !hyper.direct ? /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsxs(Col, {
            md: {
              span: 5
            },
            children: [/*#__PURE__*/_jsx("div", {
              style: {
                marginTop: '1em'
              },
              children: /*#__PURE__*/_jsx(Autocomplete, {
                multiple: true,
                disabled: !hyper.allToAll && hyper.direct,
                options: Object.keys(tableObj.dtypes),
                value: hyper.entity_types || [],
                filterSelectedOptions: true,
                renderInput: function renderInput(params) {
                  return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, params), {}, {
                    variant: "outlined",
                    label: "Columns to link",
                    placeholder: ""
                  }));
                },
                onChange: function onChange(event, newValues) {
                  setHyperedgeBindings(function (bindings) {
                    return _objectSpread(_objectSpread({}, bindings), {}, {
                      entity_types: newValues
                    });
                  });
                }
              })
            }), !(hyper.entity_types || []).length ? /*#__PURE__*/_jsx("p", {
              className: "text-danger",
              children: "Typically pick 2 or more columns to link together, or switch to mode \"Specify individual src/dst column pairs\""
            }) : null]
          }), /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsxs(Button, {
              disabled: hyper.entity_types && hyper.entity_types.length === Object.keys(tableObj.dtypes).length,
              className: styles['edge-footer-button'],
              onClick: function onClick() {
                setHyperedgeBindings(function (bindings) {
                  return _objectSpread(_objectSpread({}, bindings), {}, {
                    entity_types: Object.keys(tableObj.dtypes)
                  });
                });
              },
              children: [/*#__PURE__*/_jsx("i", {
                className: "fa fa-plus",
                alt: 'x'
              }), " Use all columns"]
            })
          })]
        }) : null, /*#__PURE__*/_jsx(Container, {
          children: !hyper.allToAll && hyper.direct ? !rows.length ? /*#__PURE__*/_jsx("p", {
            className: "text-danger",
            children: "No edge src/dst pairs defined yet: Click \"Add src/dst binding pair\" or \"Autoinfer edges\", or turn off \"Specify individual src/dst column pairs\""
          }) : rows : null
        }), /*#__PURE__*/_jsxs(Button, {
          className: "".concat(styles['edge-footer-button'], " ").concat(rows.length ? '' : styles['edge-footer-button-mt']),
          disabled: !!hyper.allToAll || !hyper.direct || rows.length === Object.keys(tableObj.dtypes).length,
          onClick: function onClick() {
            setHyperedgeBindings(function (bindings) {
              var item = {};
              for (var _i2 = 0, _Object$keys = Object.keys(tableObj.dtypes); _i2 < _Object$keys.length; _i2++) {
                var col = _Object$keys[_i2];
                if (!edges[col]) {
                  item[col] = [];
                  break;
                }
              }
              return _objectSpread(_objectSpread({}, bindings), {}, {
                opts: _objectSpread(_objectSpread({}, bindings.opts || {}), {}, {
                  EDGES: _objectSpread(_objectSpread({}, edges), item)
                })
              });
            });
          },
          children: [/*#__PURE__*/_jsx("i", {
            className: "fa fa-plus"
          }), " Add src/dst binding pair(s)"]
        }), /*#__PURE__*/_jsxs(Button, {
          className: styles['edge-footer-button'],
          onClick: function onClick() {
            var hyperedges = inferHyperedges(tableObj);
            log.info({
              inferred: {
                'from': tableObj,
                'to': hyperedges
              }
            }, 'ShaperSimple.AutoinferEdges::click');
            if (!hyperedges || !hyperedges.entity_types && !hyperedges.opts && !hyperedges.opts.EDGES) {
              return;
            }
            setHyperedgeBindings(function (bindings) {
              var opts = _objectSpread({}, bindings.opts || {});
              if (!hyperedges.opts || !hyperedges.opts.CATEGORIES) {
                if ('CATEGORIES' in opts) {
                  delete opts['CATEGORIES'];
                }
              }
              return _objectSpread(_objectSpread({}, bindings), {}, {
                allToAll: hyperedges.allToAll,
                direct: hyperedges.direct,
                entity_types: hyperedges.entity_types,
                categories: hyperedges.categories || {},
                opts: _objectSpread(_objectSpread(_objectSpread({}, opts), hyperedges.opts && hyperedges.opts.EDGES ? {
                  EDGES: _objectSpread({}, hyperedges.opts.EDGES)
                } : {}), hyperedges.opts && hyperedges.opts.CATEGORIES ? {
                  CATEGORIES: _objectSpread({}, hyperedges.opts.CATEGORIES)
                } : {})
              });
            });
          },
          children: [/*#__PURE__*/_jsx("i", {
            className: "fa fa-rocket",
            alt: 'x'
          }), " Autoinfer edges"]
        })]
      })
    }), /*#__PURE__*/_jsx(Divider, {
      className: styles['form-divider']
    }), /*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsxs(Card.Body, {
        children: [/*#__PURE__*/_jsx(Card.Title, {
          children: "Categories: Merge node IDs when they appear in different columns"
        }), /*#__PURE__*/_jsx("p", {
          children: "By default, the same ID in different columns will be treated as the same node"
        }), /*#__PURE__*/_jsxs("p", {
          children: ["Example: By default, if columns ", /*#__PURE__*/_jsx("code", {
            children: "manager_id"
          }), " and ", /*#__PURE__*/_jsx("code", {
            children: "director_id"
          }), " both have an entry \"", /*#__PURE__*/_jsx("code", {
            children: "123"
          }), "\" (and potentially on different rows), the two values will appear as the same node: ", /*#__PURE__*/_jsx("code", {
            children: "n::123"
          }), ". To instead generate two nodes, uncheck the ", /*#__PURE__*/_jsx("code", {
            children: "merge all"
          }), " button. To more precisely control the merge, such as distinguishing ", /*#__PURE__*/_jsx("code", {
            children: "employee_id::123"
          }), " (managers, directors) from ", /*#__PURE__*/_jsx("code", {
            children: "product_id::123"
          }), ", create a category from a subset of your columns"]
        }), /*#__PURE__*/_jsx(CategoryRowsComponent, {
          specifyCategories: specifyCategories,
          mergeAllCategories: mergeAllCategories,
          hyperedges: hyperedges,
          tableObj: tableObj,
          setHyperedgeBindings: setHyperedgeBindings
        })]
      })
    }), /*#__PURE__*/_jsx(Divider, {
      className: styles['form-divider']
    }), /*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsxs(Card.Body, {
        children: [/*#__PURE__*/_jsx(Card.Title, {
          children: "Additional options"
        }), /*#__PURE__*/_jsxs(Container, {
          children: [/*#__PURE__*/_jsxs(ListItem, {
            children: [/*#__PURE__*/_jsx(RcSwitch, {
              onChange: function onChange(value) {
                setHyperedgeBindings(function (bindings) {
                  return _objectSpread(_objectSpread({}, bindings), {}, {
                    dropNA: !hyper.dropNA
                  });
                });
              },
              checked: hyper.dropNA,
              checkedChildren: 'on',
              unCheckedChildren: 'on'
            }), "Skip null/nan nodes"]
          }), /*#__PURE__*/_jsxs(ListItem, {
            children: [/*#__PURE__*/_jsx(RcSwitch, {
              onChange: function onChange(value) {
                setHyperedgeBindings(function (bindings) {
                  return _objectSpread(_objectSpread({}, bindings), {}, {
                    dropEdgeAttrs: !hyper.dropEdgeAttrs
                  });
                });
              },
              checked: hyper.dropEdgeAttrs,
              checkedChildren: 'on',
              unCheckedChildren: 'on'
            }), "Drop most edge attributes"]
          })]
        })]
      })
    })]
  });
}
export function SimpleGraphShaper(props) {
  var visible = props.visible,
    user = props.user,
    files = props.files,
    visualizationBindings = props.visualizationBindings,
    setVisualizationBindings = props.setVisualizationBindings;
  var _visualizationBinding = visualizationBindings.shaper.simple,
    enabled = _visualizationBinding.enabled,
    edges = _visualizationBinding.edges,
    nodes = _visualizationBinding.nodes,
    hyperedges = _visualizationBinding.hyperedges;
  var edgesEnabled = edges.enabled,
    edgeFileIndexSelected = edges.fileIndex,
    edgeTableIndexSelected = edges.tableIndex,
    srcSelected = edges.src,
    dstSelected = edges.dst,
    edgeAttributesSelected = edges.attributes;
  var edgeTableKey = serializeTableKey(edgeFileIndexSelected, edgeTableIndexSelected);
  var edgeSrcKey = serializeColumnKey(edgeFileIndexSelected, edgeTableIndexSelected, srcSelected);
  var edgeDstKey = serializeColumnKey(edgeFileIndexSelected, edgeTableIndexSelected, dstSelected);
  var edgeAttrKeys = serializeAttributeKeys(edgeAttributesSelected);
  var nodesEnabled = nodes.enabled,
    nodeFileIndexSelected = nodes.fileIndex,
    nodeTableIndexSelected = nodes.tableIndex,
    nodeSelected = nodes.node,
    nodeAttributesSelected = nodes.attributes;
  var nodeTableKey = serializeTableKey(nodeFileIndexSelected, nodeTableIndexSelected);
  var nodeKey = serializeColumnKey(nodeFileIndexSelected, nodeTableIndexSelected, nodeSelected);
  var nodeAttrKeys = serializeAttributeKeys(nodeAttributesSelected);
  log.debug({
    props: props,
    resolved: {
      enabled: enabled,
      edges: edges,
      nodes: nodes,
      edgesEnabled: edgesEnabled,
      edgeFileIndexSelected: edgeFileIndexSelected,
      edgeTableIndexSelected: edgeTableIndexSelected,
      srcSelected: srcSelected,
      dstSelected: dstSelected,
      edgeAttributesSelected: edgeAttributesSelected,
      edgeTableKey: edgeTableKey,
      edgeSrcKey: edgeSrcKey,
      edgeDstKey: edgeDstKey,
      nodesEnabled: nodesEnabled,
      nodeFileIndexSelected: nodeFileIndexSelected,
      nodeTableIndexSelected: nodeTableIndexSelected,
      nodeSelected: nodeSelected,
      nodeAttributesSelected: nodeAttributesSelected,
      nodeTableKey: nodeTableKey,
      nodeKey: nodeKey
    }
  }, 'SimpleGraphShaper::render');
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(styles['viz-form-card-container']),
    children: [/*#__PURE__*/_jsxs("p", {
      children: [/*#__PURE__*/_jsx("i", {
        children: "Note:"
      }), " For UMAP-based visualizations, ..."]
    }), /*#__PURE__*/_jsxs(Card, {
      className: "".concat(styles['viz-form-card'], " ").concat(styles["shaper"], " ").concat(styles["shaper-".concat(edgesEnabled ? 'enabled' : 'disabled')]),
      children: [/*#__PURE__*/_jsxs(Card.Header, {
        className: styles['shaper-header'],
        children: [null
        /*
        <RcSwitch
            onChange={(value) => {
                setShapeProperties(setVisualizationBindings, 'edges', {'enabled': value});
            }}
            defaultChecked={edgesEnabled}
            checkedChildren={'on'}
            unCheckedChildren={'on'}
        />
        */, " Shape edge file"]
      }), /*#__PURE__*/_jsxs(Card.Body, {
        children: [/*#__PURE__*/_jsx(Card.Title, {
          children: "Turn each row of a table into one or more edges"
        }), /*#__PURE__*/_jsxs("p", {
          children: ["If you have a nodes file but no edges file, such as for a scatter plot, upload and specify an edges.csv that contains a header line but no rows: ", /*#__PURE__*/_jsx("code", {
            children: "src,dst"
          })]
        }), /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsx(FileTableSelector, _objectSpread(_objectSpread({}, props), {}, {
                id: 'edge-file-table-selector',
                defaultValueKey: edgeTableKey,
                valueSetter: function valueSetter(_ref9) {
                  var key = _ref9.target.value;
                  var _deserializeTableKey = deserializeTableKey(key),
                    fileIndex = _deserializeTableKey.fileIndex,
                    tableIndex = _deserializeTableKey.tableIndex;
                  log.debug({
                    key: key,
                    fileIndex: fileIndex,
                    tableIndex: tableIndex
                  }, 'edge FileTableSelector deserializeTableKey');
                  setShapeProperties(setVisualizationBindings, 'edges', {
                    fileIndex: fileIndex,
                    tableIndex: tableIndex,
                    attributes: []
                  });
                }
              }))
            }), /*#__PURE__*/_jsx(Col, {
              children: null /*<FileTableColumnSelector ... */
            }), /*#__PURE__*/_jsx(Col, {
              children: null /*<FileTableColumnSelector ... */
            })]
          })
        }), /*#__PURE__*/_jsx(HyperedgesComponent, {
          files: files,
          fileIndex: edgeFileIndexSelected,
          tableIndex: edgeTableIndexSelected,
          hyperedges: hyperedges,
          onChange: function onChange(newProps) {
            setVisualizationBindings(function (bindings) {
              log.debug({
                newProps: newProps,
                bindings: bindings
              }, 'set hyperedge props');
              return _objectSpread(_objectSpread({}, bindings), {}, {
                shaper: _objectSpread(_objectSpread({}, bindings.shaper), {}, {
                  simple: _objectSpread(_objectSpread({}, bindings.shaper.simple), {}, {
                    hyperedges: _objectSpread(_objectSpread(_objectSpread({}, bindings.shaper.simple.hyperedges), newProps), {}, {
                      opts: _objectSpread(_objectSpread({}, bindings.shaper.simple.hyperedges.opts || {}), newProps.opts || {})
                    })
                  })
                })
              });
            });
          },
          setHyperedgeBindings: function setHyperedgeBindings(componentUpdater) {
            setVisualizationBindings(function (bindings) {
              var componentHyperedgesUpdate = componentUpdater(bindings.shaper.simple.hyperedges);
              return _objectSpread(_objectSpread({}, bindings), {}, {
                shaper: _objectSpread(_objectSpread({}, bindings.shaper), {}, {
                  simple: _objectSpread(_objectSpread({}, bindings.shaper.simple), {}, {
                    hyperedges: componentHyperedgesUpdate
                  })
                })
              });
            });
          }
        })]
      })]
    }), /*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsxs(Card, {
      className: "".concat(styles['viz-form-card'], " ").concat(styles["shaper"], " ").concat(styles["shaper-".concat(nodesEnabled ? 'enabled' : 'disabled')]),
      children: [/*#__PURE__*/_jsxs(Card.Header, {
        className: styles['shaper-header'],
        children: [/*#__PURE__*/_jsx(RcSwitch, {
          onChange: function onChange(value) {
            setShapeProperties(setVisualizationBindings, 'nodes', {
              'enabled': value
            });
          },
          checked: nodesEnabled,
          checkedChildren: 'on',
          unCheckedChildren: 'on'
        }), "Shape node file ", /*#__PURE__*/_jsx("i", {
          children: "optional"
        })]
      }), /*#__PURE__*/_jsxs(Card.Body, {
        children: [/*#__PURE__*/_jsx(Card.Title, {
          children: "Enable if one of your tables has rows that represent nodes"
        }), /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsx(FileTableSelector, _objectSpread(_objectSpread({}, props), {}, {
                id: 'node-file-table-selector',
                defaultValueKey: nodeTableKey,
                valueSetter: function valueSetter(_ref10) {
                  var key = _ref10.target.value;
                  var _deserializeTableKey2 = deserializeTableKey(key),
                    fileIndex = _deserializeTableKey2.fileIndex,
                    tableIndex = _deserializeTableKey2.tableIndex;
                  setShapeProperties(setVisualizationBindings, 'nodes', {
                    fileIndex: fileIndex,
                    tableIndex: tableIndex,
                    attributes: []
                  });
                }
              }))
            }), /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsx(FileTableColumnSelector, _objectSpread(_objectSpread({}, props), {}, {
                id: 'node-file-table-selector-node',
                label: "Must match edge source/destination IDs",
                columnPrettyName: 'node id',
                fileIndex: nodeFileIndexSelected,
                tableIndex: nodeTableIndexSelected,
                defaultValueKey: nodeKey,
                valueSetter: function valueSetter(_ref11) {
                  var key = _ref11.target.value;
                  var _deserializeColumnKey = deserializeColumnKey(key),
                    fileIndex = _deserializeColumnKey.fileIndex,
                    tableIndex = _deserializeColumnKey.tableIndex,
                    node = _deserializeColumnKey.columnName;
                  log.debug({
                    key: key,
                    fileIndex: fileIndex,
                    tableIndex: tableIndex,
                    node: node
                  }, 'node FileTableSelector deserializeTableKey');
                  setShapeProperties(setVisualizationBindings, 'nodes', {
                    fileIndex: fileIndex,
                    tableIndex: tableIndex,
                    node: node
                  });
                }
              }))
            })]
          })
        })]
      })]
    })]
  });
}